import { Injectable } from '@angular/core';
import { ResponsePaging } from '../../nest-responses';
import { NestApiProvider } from '../../nest-api';
import { ResponseHistoryTrackerDto, RequestHistoryDetailTrackerDto, ResponseHistoryDetailTrackerDto } from '../dto/tracker-report.dto';
import { RequestPagingDto } from '../dto/base.dto';

@Injectable()
export class TrackerReportApi {

  private readonly service: string = '';
  private readonly model: string = 'TrackerReport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public previewMasterPB(payload: RequestPagingDto) {
    const method: string = 'POST';
    const func: string = 'previewMasterPB';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseHistoryTrackerDto>>(method, url, params, urlParams, body);
  }

  public previewPB(payload: RequestHistoryDetailTrackerDto) {
    const method: string = 'POST';
    const func: string = 'previewPB';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseHistoryDetailTrackerDto>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/tracker-report.api.ts